import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c9258d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_banner = _resolveComponent("head-banner")!
  const _component_location_btn = _resolveComponent("location-btn")!
  const _component_tiger_machine = _resolveComponent("tiger-machine")!
  const _component_local_super_buy = _resolveComponent("local-super-buy")!
  const _component_gold_dealer = _resolveComponent("gold-dealer")!
  const _component_city_select = _resolveComponent("city-select")!
  const _component_pc_Popup = _resolveComponent("pc-Popup")!
  const _component_choose_car = _resolveComponent("choose-car")!
  const _component_white_page = _resolveComponent("white-page")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home",
    style: _normalizeStyle(_ctx.styleObj)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_head_banner, {
        imgUrl: _ctx.activityInfo.topImgUrl
      }, null, 8, ["imgUrl"]),
      _createVNode(_component_location_btn, {
        bgColor: _ctx.activityInfo.subjectRgb,
        onToggleSelectCitySideBar: _ctx.toggleSelectCitySideBar
      }, null, 8, ["bgColor", "onToggleSelectCitySideBar"]),
      _createVNode(_component_head_banner, {
        imgUrl: _ctx.activityInfo.adImgUrl,
        h5AdLink: _ctx.activityInfo.h5AdLink,
        appAdLink: _ctx.activityInfo.appAdLink,
        styleObj: { 'margin-bottom': '20px' }
      }, null, 8, ["imgUrl", "h5AdLink", "appAdLink"]),
      _createVNode(_component_tiger_machine),
      _createVNode(_component_local_super_buy, {
        id: "local-super-buy",
        columnImgUrl: _ctx.activityInfo.columnAImgUrl,
        onOpenCarSideBar: _ctx.openCarSideBar
      }, null, 8, ["columnImgUrl", "onOpenCarSideBar"]),
      _withDirectives(_createVNode(_component_gold_dealer, {
        id: "gold-dealer",
        columnImgUrl: _ctx.activityInfo.columnBImgUrl,
        onOpenCarSideBar: _ctx.openCarSideBar
      }, null, 8, ["columnImgUrl", "onOpenCarSideBar"]), [
        [_vShow, _ctx.activityInfo.dealerSwitch === 1]
      ]),
      _createVNode(_component_pc_Popup, {
        show: _ctx.citySelectVisible,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.citySelectVisible) = $event)),
        popupType: 'citySidBar',
        onTogglePCPopupVisible: _ctx.togglePCPopupVisible
      }, {
        default: _withCtx(() => [
          _createVNode(_component_city_select, { onSelectCity: _ctx.selectCity }, null, 8, ["onSelectCity"])
        ]),
        _: 1
      }, 8, ["show", "onTogglePCPopupVisible"]),
      _createVNode(_component_pc_Popup, {
        show: _ctx.carSelectVisible,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.carSelectVisible) = $event)),
        popupType: 'carSidBar',
        onTogglePCPopupVisible: _ctx.toHideSelectCar
      }, {
        default: _withCtx(() => [
          _createVNode(_component_choose_car, {
            visible: _ctx.carSelectVisible,
            needSeries: false,
            needModel: false,
            onToChooseCar: _ctx.toChooseCar
          }, null, 8, ["visible", "onToChooseCar"])
        ]),
        _: 1
      }, 8, ["show", "onTogglePCPopupVisible"])
    ]),
    _createVNode(_component_white_page)
  ], 4))
}